import { Link } from "react-router-dom";

const AboutUs = ({ aboutPage }) => {
  return (
    <section id="aboutUs" className={aboutPage ? "aboutUs alt" : "aboutUs"}>
      <div className="aboutUs__main">
        <div className="aboutUs__left">
          <div
            className={
              aboutPage ? "aboutUs__left__main alt" : "aboutUs__left__main"
            }
          ></div>
          <span></span>
          {/* <img src={aboutImg} alt="" /> */}
        </div>

        <div className="aboutUs__right">
          <h2 className="featured__header__main">About Chaol Carington</h2>

          <p>
            Chaol Carington Ltd is a CAC-registered company based in Abuja
            Nigeria, dedicated to strengthening healthcare delivery through
            capacity building and reliable medical solutions. We are committed
            to empowering healthcare professionals with practical,
            industry-relevant skills through certified training programmes
            designed to meet current special needs and technical standards.
          </p>
          <p>
            Beyond training, we support clinics and hospitals with dependable
            access to quality medical and surgical equipment, machines, and
            consumables. Our goal is to bridge the gap between knowledge and
            practice by combining hands-on education with trusted supply and
            technical support services.
          </p>

          {aboutPage ? (
            <p>
              At our core, we believe better-trained professionals and reliable
              tools lead to better medical services. That is why we focus on
              quality, affordability, and continuous support for every
              institution and individual we serve.
            </p>
          ) : (
            <Link to="/about">
              <button className="btn">
                Learn More <i className="bx bx-arrow-right"></i>
              </button>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
